import Image from 'next/image';
import Link from 'next/link';

import { Button } from '@/slw/shared/ui/button';

export function HelpCenterSection() {
  return (
    <section className='py-8 flex flex-col md:flex-row items-center justify-between'>
      <div className='mb-6 md:mb-0'>
        <h2 className='text-[2rem] leading-[100%] font-bold text-black mb-12'>Help Center</h2>
        <p className='text-sm font-normal'>Check out our most popular questions.</p>
      </div>
      <Link href='/help-center'>
        <Button
          className='bg-blue-600 hover:bg-blue-700 text-white gap-4 font-bold
          transition-all w-full md:w-auto 2xl:w-[39.5rem] lg:w-[30rem]'
        >
          <Image src='/images/icon/help-center.svg' alt='Help Center' width={20} height={19} />
          SEE HELP CENTER
        </Button>
      </Link>
    </section>
  );
}
